import React from 'react';
import classNames from 'classnames';
import Content from '@/components/foundations/content';
import * as styles from './output.module.scss';
// svgs
import PlanningSvg from '@/svgs/output/planning';
import ScenarioSvg from '@/svgs/output/scenario';
import AnalysisSvg from '@/svgs/output/analysis';
import WireFrameSvg from '@/svgs/output/wireFrame';
import DesignSvg from '@/svgs/output/design';
import InspectionSvg from '@/svgs/output/inspection';

const OutputContent: React.FC = () => {
  const outputProcessAnalysis = classNames(styles.oOutputProcess, styles.single);
  const outputProcessEvaluation = classNames(styles.oOutputProcess, styles.single);

  return (
    <>
      <h2>
        <span>
          <strong>Output</strong>
          <small>成果物</small>
        </span>
      </h2>
      <h3>
        <span>仮説検証を行いながらアイデアを具現化し、サービスのユーザビリティを研ぎ澄ませていきます。</span>
      </h3>
      <dl className={styles.oOutputProcess}>
        <dt>調査</dt>
        <dd>
          <dl className={styles.oOutput}>
            <dt>プロジェクト計画書</dt>
            <dd>プロジェクト全体のアプローチや計画、スケジュールなどを明記した書類一式です。</dd>
            <dd className={styles.icon}>
              <PlanningSvg />
            </dd>
          </dl>
        </dd>
        <dd>
          <dl className={styles.oOutput}>
            <dt>ユーザーモデル定義書</dt>
            <dd>ユーザーシナリオやペルソナ定義など、プロトタイプを考える上で有用な条件づけを行います。</dd>
            <dd className={styles.icon}>
              <ScenarioSvg />
            </dd>
          </dl>
        </dd>
      </dl>
      <dl className={outputProcessAnalysis}>
        <dt>分析</dt>
        <dd>
          <dl className={styles.oOutput}>
            <dt>分析設計書</dt>
            <dd>ヒアリング・リサーチ等のプロセスを経て、指針となるグランドアプローチを策定するものです。</dd>
            <dd className={styles.icon}>
              <AnalysisSvg />
            </dd>
          </dl>
        </dd>
      </dl>
      <dl className={styles.oOutputProcess}>
        <dt>作成</dt>
        <dd>
          <dl className={styles.oOutput}>
            <dt>ペーパープロト / ワイヤー</dt>
            <dd>簡易なスケッチやワイヤーによる、UIの振る舞いや遷移関係などを表現したものです。</dd>
            <dd className={styles.icon}>
              <WireFrameSvg />
            </dd>
          </dl>
        </dd>
        <dd>
          <dl className={styles.oOutput}>
            <dt>デザインモックアップ</dt>
            <dd>ツールを使用してデザイントーンを再現し、UIの振る舞いや遷移関係も確認できるものです。</dd>
            <dd className={styles.icon}>
              <DesignSvg />
            </dd>
          </dl>
        </dd>
      </dl>
      <dl className={outputProcessEvaluation}>
        <dt>評価</dt>
        <dd>
          <dl className={styles.oOutput}>
            <dt>検証結果分析</dt>
            <dd>要求事項に対し、デザイン/設計案の妥当性を評価するものです。</dd>
            <dd className={styles.icon}>
              <InspectionSvg />
            </dd>
          </dl>
        </dd>
      </dl>
    </>
  );
};

const Output: React.FC = () => {
  return (
    <Content
      className={{ wrapper: styles.pOutput, inner: styles.lContent__inner }}
      intersection={{ visible: styles.visible, standby: styles.standby, threshold: 0.3 }}
    >
      <OutputContent />
    </Content>
  );
};

export default Output;
